// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"98b131ee","912":"0278a8cb"}[chunkId] + ".chunk.js";
};